export { default as ModalImage } from "./ModalImage";
